import React, { useContext, useEffect } from 'react';
import { FaqType } from './index';
import useIsMounted from '../../../../hooks/useIsMounted';
import CollapsibleArea from '../../../../components/CollapsibleArea';
import { TabsContext } from '../../../../components/Tabs';
import { useWeb3React } from '@web3-react/core';

type Props = {
    faq: FaqType;
    collapsed: boolean;
    toggle: () => void;
};

const FaqAccordion: React.FC<Props> = ({ faq, collapsed, toggle }) => {
    const { chainId } = useWeb3React();

    const { question, answer } = faq;

    const { updateHeight } = useContext(TabsContext);

    const isMounted = useIsMounted();

    useEffect(() => {
        updateHeight();
    }, [collapsed, updateHeight, isMounted, chainId]);

    return (
        <div className={`faq-container ${collapsed ? 'collapsed' : ''}`}>
            <div className='question' onClick={toggle}>
                <span>{question}</span>
                <div className={`arrow-container ${collapsed ? 'collapsed' : ''}`}>
                    <div className='arrow'></div>
                </div>
            </div>
            <div className='answer-container'>
                <CollapsibleArea className='answer' collapsed={collapsed}>
                    <div dangerouslySetInnerHTML={{ __html: answer }} />
                </CollapsibleArea>
            </div>
        </div>
    );
};

export default FaqAccordion;
